import PrivateRoute from 'helpers/privateRoute'

import Login from "layouts/authentication/sign-in"

import SendingReport from "layouts/sendingReport"
import SendingReportDetail from "layouts/sendingReport/detail"

import AlphanumericReport from "layouts/alphanumericReport"
import AlphanumericReportDetail from "layouts/alphanumericReport/detail"

import PhoneSearch from "layouts/phoneSearch"
import PhoneSearchDetail from "layouts/phoneSearch/detail"

import FirmReport from "layouts/firmReport"
import FirmReportDetail from "layouts/firmReport/detail"

import FastDetailReport from "layouts/firmReport/fastDetailReport"

import DailyReport from "layouts/dailyReport"
import DailyReportDetail from "layouts/dailyReport/detail"

import Queries from 'layouts/queries'

import UserManagement from 'layouts/userManagement'

import Icon from "@mui/material/Icon";

import Home from "layouts/home";

const routes = [
  {
    type: "collapse",
    name: "Login",
    key: "login",
    icon: <Icon fontSize="small">manage_accounts</Icon>,
    route: "/authentication/sign-in",
    component: <Login />,
  },
  {
    type: "collapse",
    name: "Anasayfa",
    key: "home",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/",
    component: <PrivateRoute><Home /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "Gönderim Raporu",
    key: "sendingReport",
    icon: <Icon fontSize="small">business</Icon>,
    route: "/GonderimRaporu",
    component: <PrivateRoute><SendingReport /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "Numara Sorgulama",
    key: "phoneSearch",
    icon: <Icon fontSize="small">business</Icon>,
    route: "/NumaraSorgulama",
    component: <PrivateRoute><PhoneSearch /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "Firma Raporu",
    key: "phoneSearch",
    icon: <Icon fontSize="small">business</Icon>,
    route: "/FirmaRaporu",
    component: <PrivateRoute><FirmReport /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "Alfanumerik Raporu",
    key: "alphanumericReport",
    icon: <Icon fontSize="small">business</Icon>,
    route: "/AlfanumerikRaporu",
    component: <PrivateRoute><AlphanumericReport /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "Günlük Rapor",
    key: "dailyReport",
    icon: <Icon fontSize="small"></Icon>,
    route: "/GunlukRapor",
    component: <PrivateRoute><DailyReport /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "Sorgular",
    key: "queries",
    icon: <Icon fontSize="small">business</Icon>,
    route: "/Sorgular",
    component: <PrivateRoute><Queries /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "Fast Sms Detay Raporu",
    key: "fastDetailReport",
    icon: <Icon fontSize="small">business</Icon>,
    route: "/FastDetayRaporu",
    component: <PrivateRoute><FastDetailReport /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "Gönderim Raporu Detay",
    key: "sendingReportDetail",
    icon: <Icon fontSize="small">business</Icon>,
    route: "/GonderimRaporuDetay",
    component: <PrivateRoute><SendingReportDetail /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "Numara Sorgulama Detay",
    key: "phoneSearchDetail",
    icon: <Icon fontSize="small">business</Icon>,
    route: "/NumaraSorgulamaDetay",
    component: <PrivateRoute><PhoneSearchDetail /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "Firma Raporu Detay",
    key: "firmReportDetail",
    icon: <Icon fontSize="small">business</Icon>,
    route: "/FirmaRaporuDetay",
    component: <PrivateRoute><FirmReportDetail /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "Alfanümerik Raporu Detay",
    key: "alphanumericReportDetail",
    icon: <Icon fontSize="small">business</Icon>,
    route: "/AlfanumerikRaporuDetay",
    component: <PrivateRoute><AlphanumericReportDetail /></PrivateRoute>,
  },
  {
    type: "collapse",
    name: "Günlük Rapor Detay",
    key: "dailyReportDetail",
    icon: <Icon fontSize="small">business</Icon>,
    route: "/GunlukRaporDetay",
    component: <PrivateRoute><DailyReportDetail /></PrivateRoute>,
  },  
  {
    type: "collapse",
    name: "Kullanıcı Yönetimi",
    key: "userManagement",
    icon: <Icon fontSize="small">account_box</Icon>,
    route: "/KullaniciYonetimi",
    component: <PrivateRoute><UserManagement/></PrivateRoute>,
  }, 

  
];

export default routes;